// th泰语
export default {
    CustomSelect: {
        '请选择': 'เลือก',
    },
    TopNav: {
        '创作者': 'ผู้สร้าง',
        '游客': 'ผู้เยี่ยมชม',
        '请登录后体验完整功能': 'กรุณาเข้าสู่ระบบเพื่อใช้งานฟังก์ชันเต็มรูปแบบ',
        '登录': 'เข้าสู่ระบบ',
        '免费试用': 'ทดลองใช้ฟรี',
        '退出登录': 'ออกจากระบบ',
        '个人中心': 'บัญชีของฉัน',
        '我的视频': 'วิดีโอของฉัน',
        '额度管理': 'จัดการเครดิต',
        '首页': 'หน้าหลัก',
        'AI创作': 'สร้างสรรค์ด้วย AI',
        '多参考': 'อ้างอิงหลายรายการ',
        '文本视频': 'ข้อความเป็นวิดีโอ',
        '图片视频': 'รูปภาพเป็นวิดีโอ',
        '文生图': 'ข้อความเป็นรูปภาพ',
        '图生图': 'รูปภาพเป็นรูปภาพ',
        '会员中心': 'ศูนย์สมาชิก',
        '概览': 'ภาพรวม',
        '我的创作': 'ผลงานของฉัน',
        '账单管理': 'จัดการใบแจ้งหนี้',
        '生成任务': 'งานสร้าง',
        '价格': 'ราคา',
        '新闻资讯': 'ข่าวสาร',
        '确定要退出登录吗？': 'คุณต้องการออกจากระบบหรือไม่?',
        '提示': 'คำแนะนำ',
        '确定': 'ยืนยัน',
        '取消': 'ยกเลิก',
        '退出成功': 'ออกจากระบบสำเร็จ',
        '视频展示': 'การนำเสนอวิดีโอ'
    },
    AiLayout: {
        'AI创作中心': 'ศูนย์สร้างสรรค์ด้วย AI',
        '视频生成': 'สร้างวิดีโอ',
        '图片生成': 'สร้างรูปภาพ',
        '我的作品': 'ผลงานของฉัน',
        '我的创作': 'ผลงานของฉัน',
        '今日剩余额度': 'เครดิตคงเหลือวันนี้',
        '多参考': 'อ้างอิงหลายรายการ',
        '文本视频': 'ข้อความเป็นวิดีโอ',
        '图片视频': 'รูปภาพเป็นวิดีโอ',
        '文生图': 'ข้อความเป็นรูปภาพ',
        '图生图': 'รูปภาพเป็นรูปภาพ',
    },
    HomeLayout: {
        '下一代AI视频生成平台': 'แพลตฟอร์มสร้างวิดีโอด้วย AI รุ่นต่อไป เปลี่ยนไอเดียให้เป็นจริงได้ทันที',
        '产品': 'ผลิตภัณฑ์',
        'AI视频': 'วิดีโอ AI',
        '价格方案': 'แผนราคา',
        '新闻资讯': 'ข่าวสาร',
        '支持': 'สนับสนุน',
        '帮助中心': 'ศูนย์ช่วยเหลือ',
        'API文档': 'เอกสาร API',
        '常见问题': 'คำถามที่พบบ่อย',
        '法律': 'กฎหมาย',
        '服务条款': 'ข้อกำหนดการให้บริการ',
        '隐私政策': 'นโยบายความเป็นส่วนตัว',
        '使用协议': 'ข้อตกลงการใช้งาน',
        '版权所有': 'สงวนลิขสิทธิ์',
        '客服邮箱': 'อีเมลสนับสนุน',
        '复制邮箱': 'คัดลอกอีเมล',
        '开发中': 'กำลังพัฒนา โปรดรอติดตาม!',
        '链接已复制到剪贴板': 'คัดลอกลิงก์ไปยังคลิปบอร์ดแล้ว',
    },
    MyLayout: {
        '创作者': 'ผู้สร้าง',
        '退出登录': 'ออกจากระบบ',
        '概览': 'ภาพรวม',
        '我的创作': 'ผลงานของฉัน',
        '会员中心': 'ศูนย์สมาชิก',
        '额度管理': 'จัดการเครดิต',
        '账单管理': 'จัดการใบแจ้งหนี้',
        '生成任务': 'งานสร้าง',
        '确定要退出登录吗？': 'คุณต้องการออกจากระบบหรือไม่?',
        '提示': 'คำแนะนำ',
        '确定': 'ยืนยัน',
        '取消': 'ยกเลิก',
        '退出成功': 'ออกจากระบบสำเร็จ'
    },
    Image: {
        "文本生成图片": "ข้อความเป็นรูปภาพ",
        "图片生成图片": "รูปภาพเป็นรูปภาพ",
        "用文字描述": "อธิบายภาพที่คุณต้องการด้วยคำพูด",
        "上传图片素材": "อัปโหลดวัสดุรูปภาพ รองรับการสร้างหลายรูปภาพ",
        "图片描述": "คำอธิบายรูปภาพ",
        "描述您想要的图片": "อธิบายรายละเอียดเนื้อหาของรูปภาพที่คุณต้องการสร้าง รองรับภาษาไทยหรืออังกฤษ...",
        "提示描述越详细效果越好": "เคล็ดลับ: ยิ่งอธิบายละเอียดมากเท่าไหร่ ผลลัพธ์การสร้างก็จะยิ่งดีขึ้นเท่านั้น",
        "图片素材": "วัสดุรูปภาพ",
        "预览图片": "แสดงตัวอย่าง",
        "上传图片": "อัปโหลดรูปภาพ",
        "支持格式JPGPNG": "รองรับรูปแบบ JPG, PNG",
        "最多": "สูงสุด",
        "张图片": "รูปภาพ",
        "超过大小限制": "เกินขีดจำกัด 10MB",
        "不是图片文件": "ไฟล์รูปภาพไม่ถูกต้อง",
        "最多上传": "อัปโหลดสูงสุด",
        "请先上传图片": "กรุณาอัปโหลดวัสดุรูปภาพก่อน",
        "请选择要生成的图片": "กรุณาเลือกรูปภาพที่จะสร้าง",
        "生成结果": "ผลลัพธ์การสร้าง",
        "重新生成成功": "สร้างใหม่สำเร็จ",
        "模型": "โมเดล AI",
        "请选择模型": "กรุณาเลือกโมเดลการสร้าง",
        "分辨率": "ความละเอียดเอาต์พุต",
        "请选择分辨率": "กรุณาเลือกความละเอียด",
        "图片比例": "อัตราส่วนภาพ",
        "补充描述": "คำอธิบายเพิ่มเติม (ไม่บังคับ)",
        "补充描述提示": "ไม่บังคับ: อธิบายเอฟเฟกต์หรือสไตล์เพิ่มเติมที่คุณต้องการให้รูปภาพมี",
        "开始绘制": "เริ่มวาด",
        "开始生成": "เริ่มสร้าง",
        "生成中": "กำลังสร้าง กรุณารอสักครู่...",
        "生成成功": "สำเร็จ",
        "图片生成成功": "สร้างรูปภาพสำเร็จ!",
        "作品已保存到我的作品": "บันทึกผลงานไปยัง 'ผลงานของฉัน' แล้ว",
        "继续创作": "สร้างสรรค์ต่อ",
        "查看作品": "ดูผลงาน",
        "请输入图片描述": "กรุณาใส่คำอธิบายรูปภาพ"
    },
    MyCreation: {
        '我的创作': 'ผลงานของฉัน',
        '查看和管理您的所有作品': 'ดูและจัดการผลงานทั้งหมดของคุณ',
        '预览': 'แสดงตัวอย่าง',
        '下载': 'ดาวน์โหลด',
        '编辑': 'แก้ไข',
        '分享': 'แชร์',
        '删除': 'ลบ',
        '暂无作品': 'ไม่มีผลงาน',
        '去创作': 'สร้างสรรค์',
        '确定删除': 'ยืนยันการลบ',
        '确定要删除作品': 'คุณต้องการลบผลงาน',
        '吗？': '?',
        '此操作不可恢复': 'การดำเนินการนี้ไม่สามารถยกเลิกได้ กรุณาระมัดระวัง!',
        '取消': 'ยกเลิก',
        '分享作品': 'แชร์ผลงาน',
        '复制链接': 'คัดลอกลิงก์',
        '全部': 'ทั้งหมด',
        '视频': 'วิดีโอ',
        '图片': 'รูปภาพ',
        '正在下载:': 'กำลังดาวน์โหลด: ',
        '链接已复制到剪贴板': 'คัดลอกลิงก์ไปยังคลิปบอร์ดแล้ว',
        '删除成功': 'ลบสำเร็จ'
    },
    Video: {
        "文本生成视频": "ข้อความเป็นวิดีโอ",
        "图片生成视频": "รูปภาพเป็นวิดีโอ",
        "智能视频生成": "สร้างวิดีโออัจฉริยะ",
        "输入文字描述": "ป้อนคำอธิบายข้อความ",
        "上传1-9张图片": "อัปโหลดรูปภาพ 1-9 รูป",
        "上传图片视频音频": "อัปโหลดรูปภาพ/วิดีโอ/เสียง",
        "视频描述": "คำอธิบายวิดีโอ",
        "描述您想要的视频场景": "อธิบายฉากวิดีโอที่คุณต้องการ",
        "提示": "คำแนะนำ",
        "图片素材": "วัสดุรูปภาพ",
        "最多上传": "อัปโหลดสูงสุด",
        "张": "รูปภาพ",
        "预览": "แสดงตัวอย่าง",
        "上传图片": "อัปโหลดรูปภาพ",
        "支持格式": "รูปแบบ JPG, PNG, ไม่เกิน 10MB ต่อไฟล์, สูงสุด",
        "AI": "AI ผสานรวมอย่างชาญฉลาดและจะสร้างเอฟเฟกต์การเปลี่ยนฉากที่ราบรื่น",
        "动态描述": "คำอธิบายการเคลื่อนไหว",
        "描述您希望图片如何动起来": "อธิบายว่าคุณต้องการให้รูปภาพเคลื่อนไหวอย่างไร",
        "个": "รายการ",
        "上传视频": "อัปโหลดวิดีโอ",
        "上传音频": "อัปโหลดเสียง",
        "描述您希望视频呈现的效果": "อธิบายเอฟเฟกต์วิดีโอที่คุณต้องการ",
        "模型": "โมเดล",
        "请选择模型": "กรุณาเลือกโมเดล",
        "分辨率": "ความละเอียด",
        "请选择分辨率": "กรุณาเลือกความละเอียด",
        "宽高比": "อัตราส่วนภาพ",
        "视频时长": "ระยะเวลาวิดีโอ",
        "生成音频": "สร้างเสียง",
        "开启音效": "เปิดเอฟเฟกต์เสียง",
        "静音模式": "โหมดปิดเสียง",
        "音频提示": "เคล็ดลับ: เสียงที่อัปโหลดจะใช้เป็นเพลงพื้นหลัง หากไม่อัปโหลดเสียง AI จะสร้างเพลงให้โดยอัตโนมัติ",
        "开始生成": "เริ่มสร้าง",
        "积分": "เครดิต",
        "生成中": "กำลังสร้าง",
        "生成成功": "สำเร็จ",
        "视频生成成功！": "สร้างวิดีโอสำเร็จ!",
        "作品已保存到": "บันทึกผลงานไปยัง 'ผลงานของฉัน' แล้ว",
        "继续创作": "สร้างสรรค์ต่อ",
        "查看作品": "ดูผลงาน",
        "视频预览": "แสดงตัวอย่างวิดีโอ",
        "关闭": "ปิด",
        "下载视频": "ดาวน์โหลดวิดีโอ",
        "您的浏览器不支持视频播放": "เบราว์เซอร์ของคุณไม่รองรับการเล่นวิดีโอ",
        "生成进度": "ความคืบหน้าการสร้าง",
        "描述": "คำอธิบาย",
        "时长": "ระยะเวลา",
        "秒": "วินาที",
        "视频素材": "วัสดุวิดีโอ",
        "音频素材": "วัสดุเสียง",
        "双图融合模式": "โหมดผสานสองรูปภาพ",
        "开始下载视频": "เริ่มดาวน์โหลดวิดีโอ",
        "请输入视频描述": "กรุณาใส่คำอธิบายวิดีโอ",
        "请至少上传一张图片": "กรุณาอัปโหลดรูปภาพอย่างน้อย 1 รูป",
        "请至少上传一张图片或一个视频": "กรุณาอัปโหลดรูปภาพอย่างน้อย 1 รูปหรือวิดีโอ 1 รายการ",
        "最多只能上传": "อัปโหลดสูงสุด",
        "超过": "เกิน",
        "限制": "ขีดจำกัด",
        "不是图片文件": "ไฟล์รูปภาพไม่ถูกต้อง",
        "不是视频文件": "ไฟล์วิดีโอไม่ถูกต้อง",
        "不是音频文件": "ไฟล์เสียงไม่ถูกต้อง"
    },
    Forgot: {
        "找回密码": "กู้คืนรหัสผ่าน",
        "请输入您的邮箱，我们将发送验证码": "กรุณาป้อนอีเมลของคุณ เราจะส่งรหัสยืนยันให้",
        "密码重置成功，请使用新密码登录": "รีเซ็ตรหัสผ่านสำเร็จ กรุณาเข้าสู่ระบบด้วยรหัสผ่านใหม่",
        "密码重置成功": "รีเซ็ตรหัสผ่านสำเร็จ",
        "您的密码已成功重置，请使用新密码登录": "รหัสผ่านของคุณถูกรีเซ็ตสำเร็จ กรุณาเข้าสู่ระบบด้วยรหัสผ่านใหม่ของคุณ",
        "立即登录": "เข้าสู่ระบบทันที",
        "邮箱": "อีเมล",
        "请输入注册邮箱": "กรุณาป้อนอีเมลที่ลงทะเบียน",
        "发送验证码": "ส่งรหัสยืนยัน",
        "请输入验证码": "กรุณาป้อนรหัสยืนยัน",
        "验证码": "รหัสยืนยัน",
        "新密码": "รหัสผ่านใหม่",
        "设置新密码": "ตั้งรหัสผ่านใหม่",
        "确认新密码": "ยืนยันรหัสผ่านใหม่",
        "再次输入新密码": "ป้อนรหัสผ่านใหม่อีกครั้ง",
        "重置密码": "รีเซ็ตรหัสผ่าน",
        "返回登录": "กลับไปที่หน้าเข้าสู่ระบบ",
        "验证中": "กำลังตรวจสอบ",
        "重置中": "กำลังรีเซ็ต",
        "弱": "อ่อน",
        "中": "ปานกลาง",
        "强": "แข็งแรง",
        "请输入邮箱地址": "กรุณาป้อนที่อยู่อีเมล",
        "请输入正确的邮箱格式": "กรุณาป้อนรูปแบบอีเมลที่ถูกต้อง",
        "验证码应为6位数字": "รหัสยืนยันต้องเป็นตัวเลข 6 หลัก",
        "请输入新密码": "กรุณาป้อนรหัสผ่านใหม่",
        "密码至少需要6位": "รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร",
        "请再次输入新密码": "กรุณาป้อนรหัสผ่านใหม่อีกครั้ง",
        "两次输入的密码不一致": "รหัสผ่านที่ป้อนไม่ตรงกัน",
        "验证码已发送": "ส่งรหัสยืนยันแล้ว"
    },
    Login: {
        "下一代AI视频生成平台": "แพลตฟอร์มสร้างวิดีโอด้วย AI รุ่นต่อไป",
        "一键生成": "สร้างด้วยคลิกเดียว",
        "支持4K超高清输出": "รองรับการส่งออก 4K Ultra HD",
        "多种风格模板任选": "เลือกจากเทมเพลตสไตล์มากมาย",
        "商用授权无忧使用": "ใบอนุญาตเชิงพาณิชย์ ใช้งานได้อย่างสบายใจ",
        "欢迎回来": "ยินดีต้อนรับกลับมา",
        "登录您的账号继续创作": "เข้าสู่ระบบบัญชีของคุณเพื่อสร้างสรรค์ต่อ",
        "邮箱": "อีเมล",
        "请输入邮箱地址": "กรุณาป้อนที่อยู่อีเมล",
        "密码": "รหัสผ่าน",
        "请输入您的密码": "กรุณาป้อนรหัสผ่านของคุณ",
        "记住我": "จดจำฉัน",
        "忘记密码？": "ลืมรหัสผ่าน?",
        "登录": "เข้าสู่ระบบ",
        "登录中": "กำลังเข้าสู่ระบบ",
        "还没有账号？": "ยังไม่มีบัญชี?",
        "立即注册": "ลงทะเบียนทันที",
        "请输入正确的邮箱格式": "กรุณาป้อนรูปแบบอีเมลที่ถูกต้อง",
        "请输入密码": "กรุณาป้อนรหัสผ่าน",
        "密码至少需要6位": "รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร",
        "密码不能超过20位": "รหัสผ่านต้องไม่เกิน 20 ตัวอักษร",
        "登录成功": "เข้าสู่ระบบสำเร็จ"
    },
    Register: {
        "创建账号": "สร้างบัญชี",
        "开始您的AI视频创作之旅": "เริ่มต้นการเดินทางสร้างวิดีโอด้วย AI ของคุณ",
        "姓名": "ชื่อ",
        "请输入您的姓名": "กรุณาป้อนชื่อของคุณ",
        "邮箱": "อีเมล",
        "请输入邮箱地址": "กรุณาป้อนที่อยู่อีเมล",
        "获取验证码": "รับรหัสยืนยัน",
        "验证码": "รหัสยืนยัน",
        "请输入验证码": "กรุณาป้อนรหัสยืนยัน",
        "密码": "รหัสผ่าน",
        "设置密码": "ตั้งรหัสผ่าน",
        "确认密码": "ยืนยันรหัสผ่าน",
        "再次输入密码": "ป้อนรหัสผ่านอีกครั้ง",
        "我已阅读并同意": "ฉันได้อ่านและยอมรับ",
        "服务条款": "ข้อกำหนดการให้บริการ",
        "和": "และ",
        "隐私政策": "นโยบายความเป็นส่วนตัว",
        "注册中": "กำลังลงทะเบียน",
        "已有账号？": "มีบัญชีอยู่แล้ว?",
        "立即登录": "เข้าสู่ระบบทันที",
        "弱": "อ่อน",
        "中": "ปานกลาง",
        "强": "แข็งแรง",
        "请输入姓名": "กรุณาป้อนชื่อ",
        "姓名至少需要2个字符": "ชื่อต้องมีอย่างน้อย 2 ตัวอักษร",
        "姓名不能超过20个字符": "ชื่อต้องไม่เกิน 20 ตัวอักษร",
        "请输入正确的邮箱格式": "กรุณาป้อนรูปแบบอีเมลที่ถูกต้อง",
        "验证码应为6位数字": "รหัสยืนยันต้องเป็นตัวเลข 6 หลัก",
        "请输入密码": "กรุณาป้อนรหัสผ่าน",
        "密码至少需要6位": "รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร",
        "密码不能超过20位": "รหัสผ่านต้องไม่เกิน 20 ตัวอักษร",
        "请再次输入密码": "กรุณาป้อนรหัสผ่านอีกครั้ง",
        "两次输入的密码不一致": "รหัสผ่านที่ป้อนไม่ตรงกัน",
        "验证码已发送": "ส่งรหัสยืนยันแล้ว",
        "注册成功": "ลงทะเบียนสำเร็จ"
    },
    Faq: {
        '常见问题': 'คำถามที่พบบ่อย',
        '您在使用过程中遇到的问题': 'ปัญหาที่คุณพบระหว่างการใช้งาน หาคำตอบได้ที่นี่',
        '搜索您的问题': 'ค้นหาคำถามของคุณ...',
        '没有找到相关的问题': 'ไม่พบคำถามที่เกี่ยวข้อง',
        '查看全部问题': 'ดูคำถามทั้งหมด',
        '没有找到您想要的答案？': 'ไม่พบคำตอบที่คุณต้องการ?',
        '我们的客服团队随时为您提供帮助': 'ทีมสนับสนุนของเราพร้อมให้ความช่วยเหลือคุณตลอดเวลา',
        '复制客服邮箱': 'คัดลอกอีเมลสนับสนุน',
        '链接已复制到剪贴板': 'คัดลอกลิงก์ไปยังคลิปบอร์ดแล้ว'
    },
    Home: {
        '立即订阅': 'สมัครสมาชิกเลย',
        'AI视频生成新时代': 'ยุคใหม่ของการสร้างวิดีโอด้วย AI',
        '用文字创造': 'สร้างสรรค์ด้วยคำพูด',
        '无限视频': 'วิดีโอไม่จำกัด',
        '让每个人都能成为视频创作者': 'ทำให้ทุกคนเป็นผู้สร้างวิดีโอได้ เพียงป้อนคำอธิบายข้อความก็จะได้วิดีโอ AI คุณภาพสูงที่ไม่ซ้ำใคร',
        '免费开始': 'เริ่มต้นฟรี',
        '观看演示': 'ดูตัวอย่าง',
        'AI生成': 'สร้างด้วย AI',
        'AI视频': 'วิดีโอ AI',
        '三步轻松生成专业视频': 'สามขั้นตอนง่าย ๆ ในการสร้างวิดีโอระดับมืออาชีพ',
        '输入提示词': 'ป้อนคำแนะนำ',
        '用文字描述您想要的视频内容': 'อธิบายเนื้อหาวิดีโอที่คุณต้องการด้วยคำพูด ยิ่งละเอียดยิ่งดี',
        '智能生成': 'สร้างอัจฉริยะ',
        'AI模型自动理解并创作': 'โมเดล AI เข้าใจและสร้างสรรค์โดยอัตโนมัติ การเรนเดอร์เสร็จสิ้นภายในไม่กี่นาที',
        '下载作品': 'ดาวน์โหลดผลงาน',
        '高清视频生成完成': 'สร้างวิดีโอ HD เสร็จสมบูรณ์ พร้อมดาวน์โหลดและใช้งานทันที',
        'AI视频生成': 'สร้างวิดีโอด้วย AI',
        '精彩视频': 'ป้อนคำอธิบายข้อความ AI จะสร้างวิดีโอที่ยอดเยี่ยมให้คุณ',
        '描述您想要的视频场景': 'อธิบายฉากวิดีโอที่คุณต้องการ ตัวอย่าง: ลูกแมวเล่นใต้ต้นซากุระ แสงแดดส่องผ่านกลีบดอกไม้...',
        '生成中': 'กำลังสร้าง...',
        '生成视频': 'สร้างวิดีโอ',
        'AI图片': 'รูปภาพ AI',
        '精美图片': 'ป้อนคำอธิบายข้อความ AI จะสร้างรูปภาพที่ยอดเยี่ยมให้คุณ',
        '描述您想要的图片场景': 'อธิบายฉากรูปภาพที่คุณต้องการ ตัวอย่าง: ขอบฟ้าเมืองแห่งอนาคต ไฟนีออนระยิบระยับ สไตล์ไซเบอร์พังค์...',
        '生成图片': 'สร้างรูปภาพ',
        '强大功能': 'ฟังก์ชันทรงพลัง',
        '让视频创作变得简单有趣': 'ทำให้การสร้างวิดีโอง่ายและสนุก',
        '案例展示': 'ตัวอย่าง',
        '来看看用户使用': 'มาดูผลงานยอดเยี่ยมที่สร้างโดย',
        '创作的精彩作品': 'ผู้ใช้งาน',
        '新闻资讯': 'ข่าวสาร',
        '了解': 'ติดตาม',
        '的最新动态和产品更新': 'ข่าวสารล่าสุดและการอัปเดตผลิตภัณฑ์',
        '查看更多': 'ดูเพิ่มเติม',
        '热门': 'ยอดนิยม',
        '最新': 'ล่าสุด',
        '阅读更多': 'อ่านเพิ่มเติม',
        '选择适合您的方案': 'เลือกแผนที่เหมาะกับคุณ',
        '灵活的定价': 'ราคาที่ยืดหยุ่นตอบสนองความต้องการที่แตกต่างกัน',
        '视频预览': 'แสดงตัวอย่างวิดีโอ',
        '生成成功': 'สำเร็จ',
        '作品已保存到': 'บันทึกผลงานไปยัง "ผลงานของฉัน" แล้ว',
        '继续创作': 'สร้างสรรค์ต่อ',
        '查看作品': 'ดูผลงาน',
        '请输入视频描述': 'กรุณาใส่คำอธิบายวิดีโอ',
        '视频生成成功！': 'สร้างวิดีโอสำเร็จ!',
        '请输入图片描述': 'กรุณาใส่คำอธิบายรูปภาพ',
        '图片生成成功！': 'สร้างรูปภาพสำเร็จ!',
    },
    News: {
        '新闻资讯': 'ข่าวสาร',
        '了解': 'ติดตาม',
        '的最新动态和产品更新': 'ข่าวสารล่าสุดและการอัปเดตผลิตภัณฑ์',
        '精选': 'แนะนำ',
        '阅读': 'อ่าน',
        '点赞': 'ถูกใจ',
        '热门': 'ยอดนิยม',
        '最新': 'ล่าสุด',
        '阅读更多': 'อ่านเพิ่มเติม',
        '加载中': 'กำลังโหลด...',
        '暂无新闻': 'ไม่มีข่าวสาร',
        '清除筛选': 'ล้างตัวกรอง',
        '加载新闻失败': 'โหลดข่าวสารล้มเหลว กรุณาลองอีกครั้งภายหลัง',
    },
    Price: {
        '选择适合您的方案': 'เลือกแผนที่เหมาะกับคุณ',
        '灵活的定价': 'ราคาที่ยืดหยุ่นตอบสนองความต้องการที่แตกต่างกัน',
        '包月': 'รายเดือน',
        '包年': 'รายปี',
        '购买积分': 'ซื้อเครดิต',
        '只需要几个视频': 'ต้องการวิดีโอเพียงไม่กี่รายการ? ไม่ต้องสมัครสมาชิก ซื้อแพ็กเกจเครดิตโดยตรง',
        '产品大全': 'แคตตาล็อกสินค้า',
        '了解': 'เรียนรู้',
        '全系列产品的详细信息和支付方式': 'ข้อมูลโดยละเอียดและวิธีการชำระเงินสำหรับผลิตภัณฑ์ทุกรุ่น'
    },
    Billing: {
        '账单管理': 'จัดการใบแจ้งหนี้',
        '账户余额': 'ยอดคงเหลือในบัญชี',
        '本月支出': 'ค่าใช้จ่ายเดือนนี้',
        '订单数量': 'จำนวนคำสั่งซื้อ',
        '账单列表': 'รายการใบแจ้งหนี้',
        '请选择类型': 'กรุณาเลือกประเภท',
        '请选择时间范围': 'กรุณาเลือกช่วงเวลา',
        '订单号': 'หมายเลขคำสั่งซื้อ',
        '类型': 'ประเภท',
        '金额': 'จำนวนเงิน',
        '状态': 'สถานะ',
        '时间': 'เวลา',
        '操作': 'ดำเนินการ',
        '查看详情': 'ดูรายละเอียด',
        '下载发票': 'ดาวน์โหลดใบแจ้งหนี้',
        '暂无作品': 'ไม่มีผลงาน',
        '去创作': 'สร้างสรรค์',
        '支付方式': 'วิธีการชำระเงิน',
        '添加支付方式': 'เพิ่มวิธีการชำระเงิน',
        '默认': 'ค่าเริ่มต้น',
        '设为默认': 'ตั้งเป็นค่าเริ่มต้น',
        '编辑': 'แก้ไข',
        '删除': 'ลบ',
        '账单详情': 'รายละเอียดใบแจ้งหนี้',
        '交易流水号': 'หมายเลขธุรกรรม',
        '关闭': 'ปิด',
        '账号': 'หมายเลขบัญชี/บัตร',
        '请输入账号或卡号': 'กรุณาป้อนหมายเลขบัญชีหรือบัตร',
        '姓名': 'ชื่อ',
        '请输入持卡人姓名': 'กรุณาป้อนชื่อผู้ถือบัตร',
        '有效期': 'วันหมดอายุ',
        '请输入CVV码': 'กรุณาป้อนรหัส CVV',
        '取消': 'ยกเลิก',
        '确认添加': 'ยืนยันการเพิ่ม',
        '确认修改': 'ยืนยันการแก้ไข',
        '确认删除': 'ยืนยันการลบ',
        '编辑支付方式': 'แก้ไขวิธีการชำระเงิน',
        '确定要删除支付方式': 'คุณต้องการลบวิธีการชำระเงินนี้หรือไม่?',
        '删除后不可恢复': 'การลบไม่สามารถยกเลิกได้ กรุณาระมัดระวัง!',
        '请输入账号': 'กรุณาป้อนหมายเลขบัญชี/บัตร',
        '添加成功': 'เพิ่มสำเร็จ',
        '修改成功': 'แก้ไขสำเร็จ',
        '已设为默认支付方式': 'ตั้งเป็นวิธีการชำระเงินเริ่มต้นแล้ว',
        '删除成功': 'ลบสำเร็จ',
    },
    Credit: {
        '额度管理': 'จัดการเครดิต',
        '当前可用额度': 'เครดิตที่ใช้ได้ในปัจจุบัน',
        '升级会员': 'อัปเกรดสมาชิก',
        '本月已用': 'ใช้แล้วเดือนนี้',
        '视频生成': 'สร้างวิดีโอ',
        'AI图片': 'รูปภาพ AI',
        '其他': 'อื่น ๆ',
        '购买额度包': 'ซื้อแพ็กเกจเครดิต',
        '最受欢迎': 'ยอดนิยมที่สุด',
        '额度': 'เครดิต',
        '立即购买': 'ซื้อเลย',
        '使用记录': 'ประวัติการใช้งาน',
        '操作': 'ดำเนินการ',
        '类型': 'ประเภท',
        '额度变动': 'การเปลี่ยนแปลงเครดิต',
        '时间': 'เวลา',
        '购买': 'ซื้อ',
        '确认购买': 'ยืนยันการซื้อ',
        '金额': 'จำนวนเงิน: ',
        '获得': 'รับ',
        '取消': 'ยกเลิก',
        '今天': 'วันนี้',
        '昨天': 'เมื่อวาน',
    },
    Dashboard: {
        '欢迎回来': 'ยินดีต้อนรับกลับมา,',
        '创建新视频': 'สร้างวิดีโอใหม่',
        '本月生成次数': 'จำนวนการสร้างในเดือนนี้',
        '剩余额度': 'เครดิตคงเหลือ',
        '总视频数': 'จำนวนวิดีโอทั้งหมด',
        '会员状态': 'สถานะสมาชิก',
        '最近生成': 'การสร้างล่าสุด',
        '查看全部': 'ดูทั้งหมด',
        '视频预览': 'แสดงตัวอย่างวิดีโอ',
        '视频生成中': 'กำลังสร้างวิดีโอ กรุณารอเพื่อแสดงตัวอย่าง',
    },
    Membership: {
        '会员中心': 'ศูนย์สมาชิก',
        '当前方案': 'แผนปัจจุบัน',
        'Pro 会员': 'Pro สมาชิก',
        '专业创作者首选': 'ตัวเลือกแรกสำหรับผู้สร้างมืออาชีพ',
        '月': 'เดือน',
        '会员有效期': 'อายุสมาชิก',
        '剩余天数': 'วันที่เหลือ',
        '续费会员': 'ต่ออายุสมาชิก',
        '取消订阅': 'ยกเลิกการสมัคร',
        '本月使用情况': 'การใช้งานเดือนนี้',
        '视频生成': 'สร้างวิดีโอ',
        '次': 'ครั้ง',
        '额度使用': 'การใช้เครดิต',
        '快速生成': 'สร้างรวดเร็ว',
        '升级方案': 'อัปเกรดแผน',
        '联系销售': 'ติดต่อฝ่ายขาย',
        '会员权益': 'สิทธิประโยชน์ของสมาชิก',
        '续费后将延长会员有效期30天': 'การต่ออายุจะขยายระยะเวลาสมาชิกออกไป 30 วัน',
        '取消': 'ยกเลิก',
        '确认续费': 'ยืนยันการต่ออายุ',
        '取消后您将失去所有会员权益': 'หลังยกเลิก คุณจะสูญเสียสิทธิประโยชน์ทั้งหมด แต่เครดิตคงเหลือจะยังคงอยู่',
        '再想想': 'ลองคิดดูอีกครั้ง',
        '确认取消': 'ยืนยันการยกเลิก',
        '姓名': 'ชื่อ',
        '请输入您的姓名': 'กรุณาป้อนชื่อของคุณ',
        '请输入姓名': 'กรุณาป้อนชื่อ',
        '公司': 'บริษัท',
        '请输入公司名称': 'กรุณาป้อนชื่อบริษัท',
        '邮箱': 'อีเมล',
        '请输入邮箱地址': 'กรุณาป้อนที่อยู่อีเมล',
        '请输入邮箱': 'กรุณาป้อนอีเมล',
        '请输入正确的邮箱格式': 'กรุณาป้อนรูปแบบอีเมลที่ถูกต้อง',
        '需求': 'ความต้องการ',
        '请描述您的需求': 'กรุณาอธิบายความต้องการของคุณ',
        '提交': 'ส่ง',
        '请填写需求': 'กรุณากรอกความต้องการ',
        '续费成功': 'ต่ออายุสำเร็จ! ระยะเวลาสมาชิกได้รับการขยายแล้ว',
        '已取消订阅': 'ยกเลิกการสมัครแล้ว สมาชิกจะหมดอายุเมื่อครบกำหนด',
        '提交成功': 'ส่งสำเร็จ เราจะติดต่อคุณโดยเร็วที่สุด!',
    },
    Task: {
        '生成任务': 'งานสร้าง',
        '新建任务': 'งานใหม่',
        '进行中': 'กำลังดำเนินการ',
        '已完成': 'เสร็จสิ้น',
        '失败': 'ล้มเหลว',
        '队列中': 'อยู่ในคิว',
        '活跃任务': 'งานที่กำลังดำเนินการ',
        '刷新': 'รีเฟรช',
        '暂无活跃任务': 'ไม่มีงานที่กำลังดำเนินการ',
        '预计剩余': 'เวลาที่เหลือโดยประมาณ',
        '暂停': 'หยุดชั่วคราว',
        '继续': 'ดำเนินการต่อ',
        '取消': 'ยกเลิก',
        '最近完成': 'เสร็จสิ้นล่าสุด',
        '查看全部': 'ดูทั้งหมด',
        '暂无完成的任务': 'ไม่มีงานที่เสร็จสิ้น',
        '播放': 'เล่น',
        '下载': 'ดาวน์โหลด',
        '分享': 'แชร์',
        '确认取消': 'ยืนยันการยกเลิก',
        '确定要取消任务吗': 'คุณต้องการยกเลิกงานนี้หรือไม่?',
        '已消耗的额度将无法退还': 'เครดิตที่ใช้ไปแล้วจะไม่สามารถคืนได้',
        '返回': 'กลับ',
        '分享作品': 'แชร์ผลงาน',
        '复制链接': 'คัดลอกลิงก์',
        '任务列表已刷新': 'รีเฟรชรายการงานแล้ว',
        '已暂停': 'หยุดชั่วคราว',
        '生成中': 'กำลังสร้าง',
        '已恢复': 'ดำเนินการต่อแล้ว',
        '任务已取消': 'ยกเลิกงานแล้ว',
        '链接已复制到剪贴板': 'คัดลอกลิงก์ไปยังคลิปบอร์ดแล้ว',
    },
    VideoShow: {
        '示例': 'ตัวอย่าง',
        '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。': 'คลิปที่คัดสรรมาอย่างดีจากคลังสาธิตของเรา คลิกที่การ์ดใดก็ได้เพื่อเริ่มสร้างเนื้อหาในสไตล์ที่คล้ายกัน',
        '全部': 'ทั้งหมด',
        '电影感': 'เหมือนหนัง',
        '角色': 'ตัวละคร',
        '产品': 'ผลิตภัณฑ์',
        '自然': 'ธรรมชาติ',
        '趣味': 'สนุกสนาน',
        '加载中': 'กำลังโหลด',
        '暂无展示': 'ไม่มีตัวอย่างสาธิต',
        '视频预览': 'แสดงตัวอย่างวิดีโอ',
    },
    Request: {
        '加载中': 'กำลังโหลด...',
        '您已退出登录': 'คุณได้ออกจากระบบแล้ว สามารถเข้าสู่ระบบใหม่ได้',
        '确认退出': 'ยืนยันการออกจากระบบ',
        '重新登录': 'เข้าสู่ระบบอีกครั้ง',
        '错误': 'ข้อผิดพลาด',
        '网络错误': 'ข้อผิดพลาดของเครือข่าย',
        '下载中': 'กำลังดาวน์โหลด...'
    },
    Other: {
        '剩余额度': 'ยอดคงเหลือ',
        '去登录': 'เข้าสู่ระบบ',
        '请登录后查看': 'กรุณาเข้าสู่ระบบเพื่อดู',
        '任务': 'งาน',
        '可在「生成任务」中查看详情': ' สามารถดูรายละเอียดได้ใน "งานสร้าง"',
        '查看详情': 'ดูรายละเอียด',
        '排队中': 'อยู่ในคิว',
        '运行中': 'กำลังทำงาน',
        '取消': 'ยกเลิก',
        '成功': 'สำเร็จ',
        '失败': 'ล้มเหลว',
        '超时': 'หมดเวลา',
        '最后更新': 'อัปเดตล่าสุด:',
        '视频生成': 'การสร้างวิดีโอ',
        '活跃用户': 'ผู้ใช้ที่ใช้งาน',
        '用户评分': 'คะแนนผู้ใช้',
        '万': 'พัน',
        '快速生成': 'สร้างรวดเร็ว',
        '先进的AI模型': 'โมเดล AI ขั้นสูง สร้างวิดีโอคุณภาพสูงในเวลาไม่กี่นาที',
        '多种风格': 'หลากหลายสไตล์',
        '多种风格任您选择': 'สมจริง, อะนิเมะ, อาร์ตติค และอื่นๆ ให้คุณเลือก',
        '高清输出': 'เอาต์พุตความละเอียดสูง',
        '支持4K超高清视频输出': 'รองรับการส่งออกวิดีโอ 4K Ultra HD เห็นรายละเอียดชัดเจน',
        '商用授权': 'ใบอนุญาตเชิงพาณิชย์',
        '生成的视频可用于商业用途': 'วิดีโอที่สร้างสามารถใช้เพื่อวัตถุประสงค์ทางการค้าได้ ไม่ต้องกังวลเรื่องลิขสิทธิ์',
        '原价': 'ราคาเดิม',
        '积分价格说明': 'คำอธิบายราคาคะแนน',
        '系列': 'ซีรีส์',
        '模型': 'โมเดล',
        '分辨率': 'ความละเอียด',
        '积分': 'คะแนน',
        '秒': 'วินาที',
        '秒示例': 'วินาที (ตัวอย่าง)',
        '图片模型': 'โมเดลรูปภาพ',
        '图片为': 'รูปภาพคือ',
        '系列产品': 'ผลิตภัณฑ์ในซีรีส์ รองรับ',
        '支持使用任意机型查看完整体验': ' รองรับการใช้งานทุกอุปกรณ์เพื่อประสบการณ์ที่สมบูรณ์',
        '计费方式': 'วิธีการเรียกเก็บเงิน',
        '张': 'รูปภาพ',
        '按生成张数计费': 'เรียกเก็บเงินตามจำนวนรูปภาพที่สร้าง',
        '普通用户': 'ผู้ใช้งานทั่วไป',
        '无记录': 'ไม่มีบันทึก',
        '总支出': 'ค่าใช้จ่ายทั้งหมด',
        '月总使用': 'การใช้งานรวมต่อเดือน',
        '月视频使用': 'การใช้วิดีโอต่อเดือน',
        '月图片使用': 'การใช้รูปภาพต่อเดือน',
        '生成成功': 'สร้างสำเร็จ',
        '视频总生成': 'วิดีโอที่สร้างทั้งหมด',
        '图片总生成': 'รูปภาพที่สร้างทั้งหมด',
        '生成中': 'กำลังสร้าง กรุณารอ 1-3 นาที',
        '来自我们演示库的一套精心挑选的剪辑片段': 'ชุดคลิปที่คัดสรรมาอย่างดีจากไลบรารีตัวอย่างของเรา',
        '最近7天': '7 วันที่ผ่านมา',
        '最近30天': '30 วันที่ผ่านมา',
        '本月': 'เดือนนี้',
        '上月': 'เดือนที่แล้ว',
        '选择支付方式': 'เลือกวิธีการชำระเงิน',
        '确认支付': 'ยืนยันการชำระเงิน'
    }
}